import { Component } from '@angular/core';

@Component({
  selector: 'app-services-details-section',
  imports: [],
  templateUrl: './services-details-section.component.html',
  styleUrl: './services-details-section.component.css',
})
export class ServicesDetailsSectionComponent {

}
